import {
  AmbassadorDetail,
  AmbassadorEventNotifications,
  AmbassadorMini,
  EventNotificationFrequencies,
} from '@omniafishing/core';
import { Modal } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React, { useRef } from 'react';
import { isPending } from '../../constants/loading_state';
import { useAmbassador } from '../../hooks/use_ambassador';
import { useUserAmbassadors } from '../../hooks/use_user_ambassadors';
import { OmniaButton } from '../omnia_button/omnia_button';
import { modalFooterStyles } from '../waterbody_notifications_modal/waterbody_notifications_modal';
import { UserProfileNotificationsForm } from './user_profile_notifications_form';

export interface UserProfileNotificationsModalProps {
  userProfile: AmbassadorMini;
  open: boolean;
  favorite: boolean;
  event_notifications: AmbassadorEventNotifications;
  onClose: () => void;
  onSuccess?: () => void;
  handleResponse?: (userProfile: AmbassadorDetail) => void;
}

export const UserProfileNotificationsModal = (props: UserProfileNotificationsModalProps) => {
  const { userProfile, open, onClose, favorite, event_notifications, handleResponse, onSuccess } =
    props;
  const formRef = useRef<FormInstance>();
  const { updateAmbassadorNotifications, loadingState } = useAmbassador();
  const { followAmbassador } = useUserAmbassadors();

  if (!userProfile) {
    return null;
  }

  const onOk = () => {
    const form = formRef.current;
    interface Values {
      new_fishing_report: boolean;
      new_article: boolean;
      email: string;
      frequency: EventNotificationFrequencies;
    }
    form
      .validateFields()
      .then((values: Values) => {
        const { new_fishing_report, new_article, email, frequency } = values;
        const eventNotifications = {
          new_fishing_report,
          new_article,
          frequency,
        };
        if (favorite) {
          updateAmbassadorNotifications({
            ambassador: userProfile,
            event_notifications: eventNotifications,
            email,
            onResponse: handleResponse && handleResponse,
            onCompletion: onClose,
            onSuccess,
          });
        } else {
          followAmbassador.mutate({
            ambassador: userProfile,
            event_notifications: eventNotifications,
            email,
            onResponse: handleResponse && handleResponse,
            onCompletion: onClose,
            onSuccess,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Modal
      open={open}
      title={favorite ? 'Update Your Notifications' : 'Set Your Notifications'}
      onOk={onOk}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <UserProfileNotificationsForm
        user={userProfile}
        favorite={favorite}
        event_notifications={event_notifications}
        formRef={formRef}
      />
      <div style={modalFooterStyles}>
        <OmniaButton
          kind="tertiary"
          size="lg"
          fontSize={14}
          isDisabled={isPending(loadingState)}
          onPress={() => {
            onClose();
          }}
        >
          Cancel
        </OmniaButton>
        <OmniaButton
          kind="secondary"
          size="lg"
          fontSize={14}
          onPress={onOk}
          loading={isPending(loadingState)}
        >
          {favorite ? 'Update' : 'Follow'}
        </OmniaButton>
      </div>
    </Modal>
  );
};
